/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Change_PropertyInputs */

const cs_social_hub_change_property = /** @type {(inputs: Social_Hub_Change_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit nemovitost`)
};

const en_social_hub_change_property = /** @type {(inputs: Social_Hub_Change_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change property`)
};

/**
* | output |
* | --- |
* | "Change property" |
*
* @param {Social_Hub_Change_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_change_property = /** @type {((inputs?: Social_Hub_Change_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Change_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_change_property(inputs)
	return cs_social_hub_change_property(inputs)
});